import inspector from './inspector'

const admin = {
  'INSPECTOR': inspector
}

export default admin